//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UiBetslipComboBoostNotice',
  props: {
    content: { type: String, default: '' },
    progress: { type: Number, default: 0 },
    total: { type: Number, default: 0 }
  },
  computed: {
    logged_in() {
      return this.user
    }
  }
}
